<template lang="pug">
  div.fill-height
    slot(:open="open")
    ModalWrapper(
      icon="gifts",
      :dialog="dialog",
      :header-text="$t('form.user.redeemable.title')",
      @close="close",
    )
      template(v-slot:body="")
        v-chip.bold(
          outlined,
          color="primary",
        ) {{ $t('global.point') }}: {{ user.points }}
        v-row.media(no-gutter)
          v-col(
            v-if="!redeemable.is_deactivated",
            v-for="redeemable in redeemables",
            cols="12",
            sm="4",
            :key="redeemable.id",
          )
            v-card.media_item
              v-img(
                contain,
                :src="redeemable.s3_location",
                aspect-ratio="1",
              )
              div.mask.text-sm-center(
                @click="selectItem(redeemable)",
                :class="{ active: redeemable.id === selected, disabled: redeemable.points > user.points }",
              )
                .title.white--text {{ redeemable.points }}
                .subtitle-1.white--text {{ redeemable.name }}
                .caption.white--text {{ redeemable.description }}
      template(v-slot:footer="")
        v-spacer
        v-btn(
          :disabled="isLoading",
          :ripple="false",
          color="primary",
          @click='close'
        ) {{ $t('form.user.redeemable.cancel') }}

        v-btn(
          color="primary",
          :disabled="!selected",
          :ripple="false",
          :loading="isLoading",
          @click="submit",
        ) {{ $t('form.user.redeemable.reward') }}
</template>

<script>
import { mapGetters } from 'vuex';
import ModalWrapper from '@/components/wrapper/ModalWrapper.vue';
import { progressWrapper } from '@/config/mixins';

export default {
  mixins: [progressWrapper],

  components: {
    ModalWrapper,
  },

  data: () => ({
    dialog: false,
    selected: null,
    data: {},
    isUpload: false,
  }),

  computed: {
    ...mapGetters({
      redeemables: 'redeemable/items',
      user: 'user/user',
    }),
  },

  methods: {
    open() {
      this.dialog = true;
      this.selected = null;
    },

    close() {
      this.dialog = false;
    },

    selectItem({ id, points }) {
      if (points <= this.user.points) {
        this.selected = this.selected === id ? null : id;
      }
    },

    submit() {
      this.wrapProgress(() =>
        this.$store
          .dispatch(
            `reward/redeem`,
            {
              userId: this.$route.params.id,
              redeemableId: this.selected,
            },
            { root: true },
          )
          .then(() => {
            this.$emit('updated');
            this.close();
          })
          .catch(this.setError),
      );
    },
  },
};
</script>
